const MAX_DIMENSION = 2000;
const JPEG_QUALITY = 0.85;
const SKIP_BELOW_BYTES = 1.5 * 1024 * 1024;
export const MAX_UPLOAD_BYTES = 50 * 1024 * 1024;

async function decodeImage(file) {
  if (typeof window.createImageBitmap === "function") {
    try {
      return await window.createImageBitmap(file, { imageOrientation: "from-image" });
    } catch {
      // fall through to <img> decoding
    }
  }
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("Kan afbeelding niet lezen")); };
    img.src = url;
  });
}

// Downscales large photos in the browser so a 50MB camera photo becomes ~1-2MB before upload.
export async function compressImage(file) {
  if (!file.type.startsWith("image/")) return file;
  const isHeic = /hei[cf]/i.test(file.type) || /\.hei[cf]$/i.test(file.name);
  if (file.size < SKIP_BELOW_BYTES && !isHeic) return file;

  try {
    const bitmap = await decodeImage(file);
    const width = bitmap.width || bitmap.naturalWidth;
    const height = bitmap.height || bitmap.naturalHeight;
    const scale = Math.min(1, MAX_DIMENSION / Math.max(width, height));

    const canvas = document.createElement("canvas");
    canvas.width = Math.round(width * scale);
    canvas.height = Math.round(height * scale);
    canvas.getContext("2d").drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    if (typeof bitmap.close === "function") bitmap.close();

    const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", JPEG_QUALITY));
    if (!blob || (blob.size >= file.size && !isHeic)) return file;

    const name = file.name.replace(/\.[^.]+$/, "") + ".jpg";
    return new File([blob], name, { type: "image/jpeg", lastModified: Date.now() });
  } catch {
    return file;
  }
}

export function formatBytes(bytes) {
  if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${Math.round(bytes / 1024)} KB`;
}
